/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.Contentful.GenericContentfulErrorPage.Headline';
export const Description = 'Website.Contentful.GenericContentfulErrorPage.Description';
